import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-delete-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-delete-modal.html',
    styleUrl: './confirm-delete-modal.scss',
})
export class ConfirmDeleteModal {
  itemName = input<string>('');
  
  customTitle = input<string>();
  customDescription = input<string>();

  isArabic = computed(() => document.documentElement.dir === 'rtl');

  onConfirm = output<void>();
  onCancel = output<void>();

  translations = computed(() => {
    const isAr = this.isArabic();
    return {
      title: this.customTitle() || (isAr ? 'تأكيد الحذف؟' : 'Confirm Delete?'),
      
      description: this.customDescription() || (isAr ? 'لا يمكن التراجع عن هذا الإجراء لـ' : 'This action cannot be undone for'),
      cancel: isAr ? 'إلغاء' : 'Cancel',
      delete: isAr ? 'تأكيد الحذف' : 'Confirm Delete'
    };
  });
}